import { useState, useEffect } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { motion } from 'framer-motion';

import '../styles/nav.scss';
import '../styles/App.scss';

import rangeRoverLogo from '../assets/rangeRoverLogo.svg';
import rangeRoverLogoBlack from '../assets/rangeRoverLogoBlack.svg';
import hamburgerIcon from '../assets/hamburgerIcon.svg';
import drawerMenuArrow from '../assets/drawerMenuArrow.svg';
import xIcon from '../assets/xIcon.svg';

// const width = document.body.offsetWidth;

const Nav = () => {
  const [width, setWidth] = useState();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const mobileNav = (
    <div className="mobileNav">
      <div className="mobileNav__logoCont">
        <a href="https://www.landroverusa.com/index.html" target="_blank" rel="noreferrer">
          <img src={rangeRoverLogo} alt="landrover logo" />
        </a>
      </div>
      <div className="mobileNav__menuIcon">
        <button
          onClick={() =>
            mobileNavOpen === false ? setMobileNavOpen(true) : setMobileNavOpen(false)
          }
        >
          {mobileNavOpen ? (
            <img src={xIcon} alt="x" />
          ) : (
            <img src={hamburgerIcon} alt="three lines" />
          )}
        </button>
      </div>
      {mobileNavOpen && (
        <motion.div
          initial={{ x: '200%' }}
          animate={{ x: 0 }}
          transition={{ duration: 1, delay: 0, type: 'tween', ease: 'easeInOut' }}
          className="mobileNav__drawer"
        >
          <div className="logoCont">
            <a
              href="https://www.landroverusa.com/index.html"
              target="_blank"
              rel="sponsored noopener"
            >
              <img src={rangeRoverLogoBlack} alt="land rover colored logo" />
            </a>
          </div>
          <div className="linksCont">
            <div className="singleLink">
              <img src={drawerMenuArrow} alt="green arrow" />
              <a
                href="https://sponsorcontent.cnn.com/interactive/rangerover/futureastronaut/fromJupiter/"
                className="drawerNav"
              >
                From jupiter, with Love
              </a>
            </div>
            <div className="singleLink">
              <img src={drawerMenuArrow} alt="green arrow" />
              <a
                href="https://sponsorcontent.cnn.com/interactive/rangerover/futureastronaut/welcomeToTheClub/"
                className="drawerNav"
              >
                Welcome to the club
                <p>coming soon</p>
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );

  const desktop = (
    <div className="nav">
      <div className="logoCont">
        <a href="https://www.landroverusa.com/index.html" target="_blank" rel="sponsored noopener">
          <img src={rangeRoverLogo} alt="landrover logo" />
        </a>
      </div>
      <div className="linksCont">
        <a href="https://sponsorcontent.cnn.com/interactive/rangerover/futureastronaut/fromJupiter/">
          From Jupiter, With Love
        </a>
        <a href="https://sponsorcontent.cnn.com/interactive/rangerover/futureastronaut/welcomeToTheClub/">
          Welcome to the club
        </a>
      </div>
    </div>
  );

  return (
    <>
      <BrowserView>{width < 1000 ? mobileNav : desktop}</BrowserView>{' '}
      <MobileView>{mobileNav}</MobileView>
    </>
  );
};

export default Nav;
